import { afterGet as globalAfterGet } from "services/sosInventoryService/afterGet";
import { inventoryTransactionAfterGet } from "services/sosInventoryService/inventoryTransaction/afterGet";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/transfer/schema";
import {
  transformFields,
  transformLineItemFields,
} from "services/utility/afterGet";

import { OBJECT_TYPES } from "appConstants";
import { LINE_ITEM_FIELDS } from "editConfig";

export function afterGet(record) {
  let newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  newRecord.lines = transformLineItemFields(
    newRecord.lines,
    LINE_ITEM_FIELDS[OBJECT_TYPES.TRANSFER.fullString]
  );

  newRecord = inventoryTransactionAfterGet(newRecord);
  return globalAfterGet(newRecord);
}
